import React, { memo } from 'react'

import { ArrowRight, Icon, InfoOutlined } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

/* import ExtraUsageCard from '../ExtraUsageCard/ExtraUsageCard' */
import ProgressBar from '../ProgressBar/ProgressBar'

const SUBSCRIPTION_SETTINGS_HREF = '/profile/settings#tab-settings-subscription'

function SubscribedBody({ onClose: handleClose }) {
  const t = useTranslation()
  const monthlyUsed = useThreeDStudioStore(state => state.subscription.monthlyGenerationsUsed)
  const monthlyAvailable = useThreeDStudioStore(state => state.subscription.monthlyGenerationsAvailable)
  const extraUsed = useThreeDStudioStore(state => state.subscription.extraGenerationsUsed)
  const extraAvailable = useThreeDStudioStore(state => state.subscription.extraGenerationsAvailable)
  const resetDate = useThreeDStudioStore(state => state.subscription.subscriptionResetDate)

  const isOutOfMonthly = monthlyAvailable > 0 && monthlyUsed >= monthlyAvailable
  const showExtraBar = extraUsed > 0 || extraAvailable > 0

  return (
    <div className="usage-modal__subscribed">
      {isOutOfMonthly && (
        <p className="usage-modal__warning-headline cgt-heading-200">
          {t('usageModal.subscribed.outOfGenerations')}
        </p>
      )}

      <div className="usage-modal__subscribed-content">
        <ProgressBar
          label={t('usageModal.subscribed.monthlyGenerationsUsedLabel')}
          used={monthlyUsed}
          total={monthlyAvailable}
        />

        {resetDate && (
          <div className="usage-modal__inline-info cgt-body-base">
            <Icon
              svgComponent={InfoOutlined}
              color="dark"
              size="small"
              notSpaced
              className="usage-modal__inline-info-icon"
            />
            <span className="usage-modal__reset-date">
              {t('usageModal.subscribed.resetDateLabel')}
              {' '}
              <span className="usage-modal__reset-date cgt-caption-semibold">{resetDate}</span>
            </span>
          </div>
        )}

        {showExtraBar && (
          <ProgressBar
            label={t('usageModal.subscribed.extraGenerationsUsedLabel')}
            used={extraUsed}
            total={extraAvailable}
          />
        )}

        {/* Enable when top-ups are enabled */}
        {/* <ExtraUsageCard onClose={handleClose} /> */}

        <a
          className="usage-modal__footer-link cgt-link-primary cgt-body-md-semibold"
          href={SUBSCRIPTION_SETTINGS_HREF}
          onClick={handleClose}
        >
          <span>{t('usageModal.subscribed.subscriptionSettings')}</span>
          <Icon
            svgComponent={ArrowRight}
            color="primary"
            size="small"
            notSpaced
          />
        </a>
      </div>
    </div>
  )
}

SubscribedBody.propTypes = {
  onClose: func.isRequired,
}

export default memo(SubscribedBody)
